/**
 * taskSounds.js
 * Web Audio API utilities for task-related audio feedback.
 * Falls back silently when audio context is unavailable.
 */

/**
 * Play a short ascending "ding" when a new task is created.
 * Two-tone chirp: 660 Hz → 880 Hz, 250 ms total.
 */
export const playTaskCreatedSound = () => {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();

    osc.connect(gain);
    gain.connect(ctx.destination);

    osc.type = 'sine';
    // Ascending chirp — distinct from the messaging beep (880→660)
    osc.frequency.setValueAtTime(660, ctx.currentTime);
    osc.frequency.linearRampToValueAtTime(1047, ctx.currentTime + 0.12);

    gain.gain.setValueAtTime(0, ctx.currentTime);
    gain.gain.linearRampToValueAtTime(0.25, ctx.currentTime + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.25);

    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + 0.25);
    osc.onended = () => ctx.close();
  } catch (_) {
    // Browser hasn't had user interaction yet, or audio blocked — ignore.
  }
};
